<template>
  <div v-if="!finalStep && currentStep && !loading" class="form container">
    <div class="form__first">
       <div class="col-sm-12 form__section" v-for="(section, idx) in currentStep.inputSections">
      <div class="row" :key="idx" v-if="section.inputFields.length">
        <h3 class="form__title col-sm-12">{{ translate(section.title) }}</h3>

        <h3 class="form__subtitle col-sm-12" v-if="section.subTitle">{{ translate(section.subTitle) }}</h3>
        <div
          :class="{'col-sm-12' : !recaptchaInputType(field),
                   'col-sm-6 col-sm-offset-3' : recaptchaInputType(field)}"
          v-for="(field, idx) in section.inputFields">
            <onboard-date-input
            v-if="dateInputType(field)"
            :key="idx"
            :name="field.fieldKey"
            :type="field.attributes.htmlType"
            :label="translate(field.multiLanguageLabel)"
            :required="field.required"
            :validators="field.fieldValidators"
            @fieldUpdated="handleFieldUpdate" />

            <onboard-text-input
            v-if="textInputType(field)"
            :key="idx"
            :name="field.fieldKey"
            :type="field.attributes.htmlType"
            :label="translate(field.multiLanguageLabel)"
            :placeholder="translate(field.multiLanguagePlaceholder)"
            :required="field.required"
            :validators="field.fieldValidators"
            @fieldUpdated="handleFieldUpdate" />

            <onboard-phone-number-input
            v-if="phoneNumberInputType(field)"
            :key="idx"
            :name="field.fieldKey"
            :type="field.attributes.htmlType"
            :label="translate(field.multiLanguageLabel)"
            :placeholder="translate(field.multiLanguagePlaceholder)"
            :required="field.required"
            :validators="field.fieldValidators"
            :options="field.options"
            @fieldUpdated="handleFieldUpdate" />

            <onboard-login-name-input
            v-if="loginNameInputType(field)"
            :key="idx"
            :name="field.fieldKey"
            :type="field.attributes.htmlType"
            :label="translate(field.multiLanguageLabel)"
            :placeholder="translate(field.multiLanguagePlaceholder)"
            :validators="field.fieldValidators"
            :fields="currentlyFilledFields"
            @fieldUpdated="handleFieldUpdate" />

            <onboard-checkbox-input
            v-if="checkboxInputType(field)"
            :key="idx"
            :name="field.fieldKey"
            :type="field.attributes.htmlType"
            :label="translate(field.multiLanguageLabel)"
            :required="field.required"
            :validators="field.fieldValidators"
            @fieldUpdated="handleFieldUpdate" />

            <onboard-card-pan-input
            v-if="cardPanInputType(field)"
            :panDigits="JSON.parse(field.attributes.format)"
            :key="idx"
            :name="field.fieldKey"
            :type="field.attributes.htmlType"
            :label="translate(field.multiLanguageLabel)"
            :placeholder="translate(field.multiLanguagePlaceholder)"
            :required="field.required"
            :validators="field.fieldValidators"
            @fieldUpdated="handleFieldUpdate" />

            <Recaptcha
            v-if="recaptchaInputType(field)"
            :key="idx"
            :name="field.fieldKey"
            :type="field.htmlType"
            :required=true
            :validators="field.fieldValidators"
            @fieldUpdated="handleFieldUpdate">
            </Recaptcha>
         </div>
      </div>
    </div>
      <div class="text-centered col-sm-12 form__section mb-md mt-sm">
        <button class="hero-wrap__btn btn btn--red col-centered submit-button"
          :class="isFormInvalid ? 'button-red-disabled':''"
          :disabled="isFormInvalid" @click="nextStep">
            {{ $t('buttons.next') }}
        </button>
      </div>
    </div>
  </div>
  <div v-else-if="loading" class="container">
    <modal name="loading-modal"
      :adaptive="true"
      :clickToClose="false"
      :max-width="800"
      :max-height="400"
      :pivotY="0.2"
      width="50%"
      height="50%">
      <div class="modal-content">
        <div class="modal-content-spinner">
          <pulse-loader :color="'red'"></pulse-loader>
        </div>
        <p class="center">{{ translate(loadingMessage) }}</p>
     </div>
    </modal>
  </div>
  <div v-else-if="finalStep" class="container">
    <div class="form-create">
      <div class="row">
        <div class="col-md-6 col-centered">
          <h2>{{ translatedFinalMessage.header }}</h2>
          <p>{{ translatedFinalMessage.message }}</p>
          <span v-if="!enrollmentSuccesfull && currentStep"
            class="linkColor"
            @click="showModalEnteredData">{{ $t('labels.ReviewEnteredData') }}</span>
        </div>
      </div>
    </div>
    <modal name="entered-data"
      :adaptive="false"
      :pivotY="0.2"
      :max-width="500">
       <div class="col-md-12 form__dataReview">
        <div class="row" v-for="(field) in getAllFilledFields(currentlyFilledFields, fields, currentStep)">
        <span class="form__label">
          <label :for="field.key" class="form__label-title">{{translate(field.multiLanguageLabel)}}</label>

            <input class="form__input" type="text" v-if="cardPanInputType(field)" :value="printEnteredPAN(field)" disabled />

           <input class="form__input"
            v-else
            :id="field.key"
            :name="field.key"
             type="text"
            :value="field | formatObject"
            disabled />
      </span>
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
import Vue from 'vue';
import { mapActions } from 'vuex';
import PulseLoader from 'vue-spinner/src/PulseLoader.vue';
import moment from 'moment';
import OnboardCardPanInput from './OnboardCardPanInput.vue';
import OnboardTextInput from './OnboardTextInput.vue';
import OnboardPhoneNumberInput from './OnboardPhoneNumberInput.vue';
import OnboardDateInput from './OnboardDateInput.vue';
import OnboardLoginNameInput from './OnboardLoginNameInput.vue';
import OnboardCheckboxInput from './OnboardCheckboxInput.vue';
import Recaptcha from './OnboardRecaptcha.vue';
import minDelay from '../tools/mindelay';

export default {
  name: 'OnboardForm',
  components: {
    OnboardTextInput, OnboardPhoneNumberInput, OnboardDateInput, OnboardLoginNameInput, OnboardCheckboxInput, OnboardCardPanInput, PulseLoader, Recaptcha,
  },
  data() {
    return {
      fields: [{
        value: {
          type: String,
        },
        key: {
          type: String,
        },
        error: {
          type: Boolean,
        },
        multiLanguageLabel: [],
      }],
      loadingMessage: '',
      loading: false,
    };
  },
  watch: {
    currentStep() {
      if (this.currentStep) {
        if (this.currentStep.id === 1) {
          this.currentStep.inputSections[this.currentStep.inputSections.length - 1].inputFields.push({ fieldKey: 'recaptcha', attributes: { htmlType: 'text' }, required: true });
        }
        let fieldKeys = [];
        this.currentStep.inputSections.forEach((section) => {
          fieldKeys = fieldKeys.concat(section.inputFields.map(a => {
            return {
              key: a.fieldKey,
              multiLanguageLabel: a.multiLanguageLabel,
              htmlType: a.attributes.htmlType,
            };
          }));
        });
        this.fields = fieldKeys.map(a => {
          const rObj = {};
          rObj.key = a.key;
          rObj.error = false;
          rObj.touched = false;
          rObj.multiLanguageLabel = a.multiLanguageLabel;
          rObj.htmlType = a.htmlType;
          return rObj;
        });
      }
    },
  },
  computed: {
    currentLanguage() {
      return this.$store.state.currentLanguage;
    },
    finalStep() {
      return this.$store.getters.finalStep;
    },
    enrollmentSuccesfull() {
      return this.$store.getters.enrollmentSuccesfull;
    },
    translatedFinalMessage() {
      return this.$store.getters.translatedFinalMessage;
    },
    currentStep() {
      return this.$store.getters.currentStep;
    },
    isFormInvalid() {
      return this.fields.some((element) => !element.touched || element.error);
    },
    currentlyFilledFields() {
      return this.$store.state.currentFields;
    },
  },
  methods: {
    ...mapActions(['putStep']),
    nextStep() {
      this.loading = true;
      this.loadingMessage = this.currentStep.loadingMessage;
      const currentStepIndex = this.currentStep.id;
      const self = this;
      Vue.nextTick(() => this.$modal.show('loading-modal'));
      minDelay(this.putStep(this.getAllFields(this.currentlyFilledFields, this.fields, currentStepIndex)), 3000)
        .then(() => {
          const intervalId = setInterval(() => {
            if (self.finalStep || (currentStepIndex !== self.currentStep.id)) {
              self.loading = false;
              self.loadingMessage = '';
              self.$modal.hide('loading-modal');
              clearInterval(intervalId);
            }
          }, 3000);
        });
    },
    printEnteredPAN(field) {
      let output = '';
      let i = 1;
      let item;

      for (i; i <= 16; i += 1) {
        item = this.findPanItem(field, i);
        if (!item) {
          output += 'X';
        } else {
          output += item.Digit;
        }
        if (i % 4 === 0) {
          output += ' ';
        }
      }
      return output;
    },
    findPanItem(field, index) {
      return field.value.find((element) => { return element.Position === index; });
    },
    showModalEnteredData() {
      window.scrollTo(0, 0);
      this.$modal.show('entered-data');
    },
    textInputType(field) {
      return field.attributes.htmlType !== 'date' && field.attributes.htmlType !== 'checkbox' && field.attributes.htmlType !== 'tel' && field.fieldKey !== 'LoginName' && field.fieldKey !== 'recaptcha' && field.fieldKey !== 'CardPAN';
    },
    phoneNumberInputType(field) {
      return field.attributes.htmlType === 'tel';
    },
    loginNameInputType(field) {
      return field.attributes.htmlType !== 'date' && field.attributes.htmlType !== 'checkbox' && field.fieldKey === 'LoginName' && field.fieldKey !== 'recaptcha' && field.fieldKey !== 'CardPAN';
    },
    dateInputType(field) {
      return field.attributes.htmlType === 'date';
    },
    checkboxInputType(field) {
      return field.attributes.htmlType === 'checkbox' && field.fieldKey !== 'recaptcha';
    },
    recaptchaInputType(field) {
      return field.fieldKey === 'recaptcha';
    },
    cardPanInputType(field) {
      return field.fieldKey === 'CardPAN';
    },
    handleFieldUpdate(validation, name) {
      const updatedItem = this.fields.find((element) => { return element.key === name; });
      updatedItem.touched = true;
      updatedItem.error = validation.$invalid;
      updatedItem.value = validation.$model;
    },
    translate(multiLanguageLabel) {
      if (multiLanguageLabel) {
        const label = multiLanguageLabel.find((element) => { return element.language.code === this.currentLanguage; });
        if (label) {
          return label.text;
        }
        return multiLanguageLabel.find((element) => { return element.language.code === 'en'; }).text;
      }
      return '';
    },
    getAllFields(filledFields, currentFields, currentStepIndex) {
      const allFields = filledFields.map((elem) => {
        return {
          fieldKey: elem.fieldKey, value: elem.value, multiLanguageLabel: elem.multiLanguageLabel, htmlType: elem.htmlType,
        };
      });

      const updatedFields = allFields.concat(currentFields.map((elem) => {
        return {
          fieldKey: elem.key, value: elem.value, multiLanguageLabel: elem.multiLanguageLabel, htmlType: elem.htmlType,
        };
      }));

      const filteredFields = updatedFields.filter((elem) => {
        return !(elem.fieldKey === 'recaptcha' && currentStepIndex !== 1) && elem.fieldKey.indexOf('TermsAndConditions') !== 0;
      });
      return filteredFields;
    },
    getAllFilledFields(filledFields, currentFields, currentStep) {
      if (!currentStep) {
        return null;
      }
      const allFields = this.getAllFields(filledFields, currentFields, currentStep.id);
      const filteredFields = allFields.filter((elem) => {
        return !(elem.fieldKey === 'recaptcha');
      });
      return filteredFields.filter((elem) => elem.value !== '' && elem.value !== undefined);
    },
  },
  filters: {
    formatObject(objectValue) {
      if (objectValue.htmlType === 'date') {
        return moment(objectValue.value).format('LL');
      }
      return objectValue.value;
    },
  },
};
</script>
<style scoped>
.form__dataReview {
  padding-left: 50px;
  padding-right: 50px;
}
.form__dataReview:first-child {
  margin-top: 25px;
}
.form__dataReview:last-child {
  margin-bottom: 5px;
}
input[type="text"]:disabled {
  background: white;
}
.v--modal-overlay {
  overflow: auto;
  background-color: rgba(0,0,0,0.4);
  height: calc(100vh - 96px);
}
</style>
